import React, { useEffect, useState } from "react";
import axios from "axios";
import "./LeaderBoard.scss";
import api from "../api/api";

const LeaderBoard = ({ quizId }) => {
  const [topScorers, setTopScorers] = useState([]);

  useEffect(() => {
    const fetchLeaderboard = async () => {
      try {
        const res = await api.fetchLeaderboard(quizId);
        setTopScorers(res.data.data?.topScorers || []);
      } catch (error) {
        console.error("Error fetching leaderboard:", error);
      }
    };

    if (quizId) fetchLeaderboard();
  }, [quizId]);

  const getMedal = (index) => {
    if (index === 0) return "🥇";
    if (index === 1) return "🥈";
    if (index === 2) return "🥉";
    return `#${index + 1}`;
  };

  return (
    <div className="leaderboard-container">
      <h2>🏆 Top Scorers</h2>
      <div className="leaderboard-grid">
        {topScorers.map((user, index) => (
          <div className="leaderboard-card" key={index}>
            <div className="rank-badge">{getMedal(index)}</div>
            <p>
              👤 <strong>{user.username}</strong>
            </p>
            <p>
              🏁 <strong>Score:</strong> {user.score} / {user.maxScore}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LeaderBoard;
